import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const StyledHeader = styled.h4`
    background-color: #eeeef4;
    padding: 15px;
`;

const StyledPara = styled.p`
    min-height: 52px;
    line-height: 24px;
    padding: 15px;
`;

const AboutAddMember: React.FC = () => (
    <>
        <StyledHeader>
            <FormattedMessage id="member.add_member.about.header" />
        </StyledHeader>
        <StyledPara>
            <FormattedMessage id="member.add_member.about.description" />
        </StyledPara>
    </>
);

export default AboutAddMember;
